(function () {
    'use strict';

    angular
        .module('app')
        .controller('RescheduleConcertController', RescheduleConcertController);

    RescheduleConcertController.$inject = ['$http', '$rootScope', '$stateParams', '$state', '$filter', '$scope', 'dialog', 'cache', 'dateParser'];

    function RescheduleConcertController($http, $rootScope, $stateParams, $state, $filter, $scope, dialog, cache, dateParser) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.no_scroll = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.hideSplashAndShowForm = hideSplashAndShowForm;
        vm.goToConcertMoveReview = goToConcertMoveReview;
        vm.moveConcert = moveConcert;


        $scope.$on('$destroy', function () {
            $rootScope.no_scroll = false;
        });

        function init() {
            vm.slug = $stateParams.concert_slug;
            vm.showBeforeYouStart = true;
            vm.showMoveConcertForm = false;
            vm.showReviewMoveConcert = false;

            switch ($stateParams.language) {
                case 'da':
                    vm.datePlaceholder = 'DD.MM.ÅÅÅÅ'
                    break;
                case 'en':
                    vm.datePlaceholder = 'DD.MM.YYYY'
                    break;
                case 'sv':
                    vm.datePlaceholder = 'DD.MM.ÅÅÅÅ'
                    break;
            }
            vm.uiDateOptions = angular.copy($rootScope.uiDateConfig);
            vm.uiDateOptions.minDate = new Date();

            getUser();
            getContent();
        }

        function hideSplashAndShowForm() {
            vm.showBeforeYouStart = false;
            vm.showMoveConcertForm = true;
            vm.showReviewMoveConcert = false;
        }

        function goToConcertMoveReview() {
            if (!vm.MoveConcertForm.$valid) {
                return;
            }

            vm.showBeforeYouStart = false;
            vm.showMoveConcertForm = false;
            vm.showReviewMoveConcert = true;
            document.querySelector('.component').scrollTo(0,0);
        }

        function set_dates() {
            if (vm.concert.concert_end_time !== undefined) vm.concert.concert_end_time.setFullYear(vm.concert.concert_date.getFullYear(), vm.concert.concert_date.getMonth(), vm.concert.concert_date.getDate());
            if (vm.concert.concert_door_time !== undefined) vm.concert.concert_door_time.setFullYear(vm.concert.concert_date.getFullYear(), vm.concert.concert_date.getMonth(), vm.concert.concert_date.getDate());
            if (vm.concert.concert_start_time !== undefined) vm.concert.concert_start_time.setFullYear(vm.concert.concert_date.getFullYear(), vm.concert.concert_date.getMonth(), vm.concert.concert_date.getDate());
        }

        function moveConcert() {
            if (!vm.MoveConcertForm.$valid) {
                return;
            }

            set_dates();

            var data = {
                concert_start_time: $filter('date')(vm.concert.concert_start_time, 'yyyy-MM-dd HH:mm') + ':00',
                concert_end_time: $filter('date')(vm.concert.concert_end_time, 'yyyy-MM-dd HH:mm') + ':00',
                concert_door_time: $filter('date')(vm.concert.concert_door_time, 'yyyy-MM-dd HH:mm') + ':00',
                concert_date: vm.concert.concert_date,
                move_message: vm.move_message,
                reason: vm.reason,
            };
            vm.sending_request = true;

            return $http.patch('api/concerts/move/' + vm.concert.concert_slug, data)
                .then(function (response) {
                    if (cache.exists('upcoming_concerts')) {
                        cache.reset('upcoming_concerts');
                    }
                    vm.sending_request = false;
                    vm.showBeforeYouStart = false;
                    vm.showMoveConcertForm = false;
                    vm.showReviewMoveConcert = false;
                    vm.showAfterMoveSplash = true;
                    $scope.$applyAsync();
                });
        }

        function getUser() { //Gets information about the currently logged-in user
            $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                })
        }

        function close() {
            if (cache.exists('upcoming_concerts')) {
                cache.reset('upcoming_concerts');
            }
            $state.go('member');
        }

        function getContent() {
            return $http.get('api/concerts/' + vm.slug + '/')
                .then(function (response) {
                    vm.concert = response.data;
                    vm.concert.concert_date = dateParser.parseDate(response.data.concert_start_time);
                    vm.concert.concert_start_time = dateParser.parseDate(response.data.concert_start_time);
                    vm.concert.concert_end_time = dateParser.parseDate(response.data.concert_end_time);
                    vm.concert.concert_door_time = dateParser.parseDate(response.data.concert_door_time);
                });
        }
    }
})();
